import { TransactionView } from '../../../types/entity-types';
import { isInternalTransfer } from './is-internal-transfer';

/**
 * Checks if a transaction is an internal transfer.
 * Internal transfers are identified by checking if the transaction's vendor
 * is categorized under "Financial Items" > "Internal Transfers".
 */
export const isTransactionInternalTransfer = (transaction: TransactionView): boolean => {
  return isInternalTransfer(transaction);
};

/**
 * Filters out internal transfers from a list of transactions.
 */
export const filterInternalTransfers = (transactions: TransactionView[]): TransactionView[] => {
  return transactions.filter((t) => !isTransactionInternalTransfer(t));
};
